module.exports = __webpack_public_path__ + "img/gerejabaru.ded8760d.jpg";